import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Picker, Button } from '../root/components/common'
import DeTerms from './de-terms'
import EnTerms from './en-terms'
import * as actions from '../root/actions'
import { Redirect } from 'react-router-dom'
import {
    LOCALE_CODES,
    TERMS_LOCALE_DISPLAY_OPTIONS,
    LOCAL_DATA_KEY
} from '../root/constants'
import { Box, Typography } from '@material-ui/core'
import { UserNotificationsSettings } from 'web/src/app/root/components/common/user-notifications-settings'
import { Wizard, useWizard } from 'react-use-wizard'
import Modal from './../root/components/common/modal'
import { Header } from '../user-management/components/create-user/header/header'
import { logout as logoutUser } from '../root/actions'
import { useHistory } from 'react-router-dom'
const useStyles = makeStyles(theme => ({
    root: {
        minHeight: '90vh',
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    wrapper: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: 48
    },
    termsWrapper: {
        width: '80%',
        flex: 5,
        overflowY: 'auto'
    },
    actionsWrapper: {
        display: 'flex',
        position: 'relative',
        width: '80%',
        paddingTop: 20
    },
    buttonsWrapper: {
        display: 'flex',
        gap: 20,
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)'
    },
    termsAndServicesContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 'inherit'
    },
    termsAndServicesWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '80%',
        height: '80vh',
        paddingBottom: 50,
        '-webkit-box-shadow': '0px 0px 15px 0px rgba(179,179,179,1)',
        '-moz-box-shadow': '0px 0px 15px 0px rgba(179,179,179,1)',
        boxShadow: '0px 0px 15px 0px rgba(179,179,179,1)'
    },
    notificationsWrapper: {
        width: '80%',
        marginTop: 20
    },
    notificationHeading: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: 'bold',
        fontSize: 30,
        textAlign: 'center',
        paddingBottom: 40
    },
    modal: {
        minHeight: '100vh',
        maxHeight: '100vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    }
}))

export default function TermsAndServices() {
    const classes = useStyles()
    const dispatch = useDispatch()
    const [pageContentId, setPageContentId] = useState(1)

    const {
        token,
        isTermsStep,
        tempCreds,
        locale,
        localeCode,
        userNotificationsSettings
    } = useSelector(state => state.main)
    const isLoggedIn = token !== null
    const history = useHistory()

    const [lang, setLang] = useState(
        TERMS_LOCALE_DISPLAY_OPTIONS.hasOwnProperty(localeCode)
            ? localeCode
            : LOCALE_CODES.de
    )

    const logout = () => {
        localStorage.removeItem(LOCAL_DATA_KEY)
        dispatch(logoutUser())
        history.push('/')
    }

    const onLangChange = value => {
        setLang(value)
        dispatch(actions.setLocale(value))
    }

    const acceptTS = () => {
        dispatch(actions.loginWithTs(tempCreds))
    }

    let TermsComponent = DeTerms
    switch (lang) {
        case LOCALE_CODES.en:
            TermsComponent = EnTerms
            break
        case LOCALE_CODES.de:
            TermsComponent = DeTerms
            break
        default:
            TermsComponent = DeTerms
    }

    useEffect(() => {
        return () => {
            dispatch(actions.setIsTermsStep(false))
            dispatch(actions.setTempCreds(null))
            dispatch(actions.setCleanUserNotificationsSettings())
        }
    }, [])

    useEffect(() => {
        if (isLoggedIn) {
            dispatch(actions.profileUpdateRequest(userNotificationsSettings))
        }
    }, [isLoggedIn])

    const setNotificationsSettingsHandler = data => {
        dispatch(actions.setUserNotificationsSettings(data))
    }

    return (
        <Modal size="xl" className={classes.modal} open={true}>
            {isLoggedIn && !isTermsStep && (
                <Redirect to={{ pathname: '/dashboard' }} />
            )}
            {!isLoggedIn && !isTermsStep && (
                <Redirect to={{ pathname: '/login' }} />
            )}
            {!isLoggedIn && isTermsStep && (
                <div className={classes.root}>
                    <Wizard header={<Header onClose={logout} />}>
                        <UserNotificationsSettings
                            userNotificationsSettings={
                                userNotificationsSettings
                            }
                            setNotificationsSettingsHandler={
                                setNotificationsSettingsHandler
                            }
                        />
                        <TermsComponent acceptTs={acceptTS} />
                    </Wizard>
                </div>
            )}
        </Modal>
    )
}

{
    /* <Box className={classes.actionsWrapper}>
                        <Picker
                            onChange={onLangChange}
                            value={lang}
                            options={TERMS_LOCALE_DISPLAY_OPTIONS}
                        />
                        <Box className={classes.buttonsWrapper}>
                            {pageContentId !== 1 && (
                                <Button
                                    reverted
                                    onClick={() =>
                                        setPageContentId(
                                            prevState => prevState - 1
                                        )
                                    }>
                                    {locale.common.back}
                                </Button>
                            )}
                            <Button
                                onClick={() => {
                                    pageContentId !== 3 &&
                                        setPageContentId(
                                            prevState => prevState + 1
                                        )

                                    pageContentId === 3 && acceptTS()
                                }}>
                                {pageContentId === 3
                                    ? locale.common.acceptTerms
                                    : locale.common.next}
                            </Button>
                        </Box>
                    </Box>
                </>
            )}
        </Box>
    )
                        <Box className={classes.buttonsWrapper}>
                            <Button reverted onClick={Wizard.prevStep}>
                                {locale.common.back}
                            </Button>
                            <Button onClick={acceptTS}>
                                {locale.common.acceptTerms}
                            </Button>
                        </Box>
                    </Box> */
}
{
    /* <Box className={classes.actionsWrapper}>
    <Box className={classes.buttonsWrapper}>
        <Button
            disabled={!isNextEnabled}
            onClick={nextStep}>
            {locale.common.next}
        </Button>
    </Box>
</Box> */
}
